import React from "react";
import { Target, TrendUp, Buildings } from "@phosphor-icons/react";
import { Reveal, SectionLabel } from "./motion";
import { useLang } from "@/LanguageContext";

const ICONS = [Target, Buildings, TrendUp];

export default function WhatWeDo() {
  const { t } = useLang();
  return (
    <section id="what-we-do" data-testid="what-we-do-section" className="relative py-24 lg:py-32 bg-surface">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-3xl">
          <Reveal><SectionLabel>{t.whatWeDo.eyebrow}</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white mt-6 tracking-[-0.01em]">{t.whatWeDo.title}</h2>
          </Reveal>
        </div>
        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {t.whatWeDo.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.08} y={50}>
                <div className="h-full border border-white/10 rounded-sm p-8 lg:p-10 bg-navy/40 hover:border-gold/40 transition-colors duration-500">
                  <Icon weight="duotone" size={40} className="text-gold" />
                  <h3 className="font-serif text-xl sm:text-2xl text-white mt-6">{item.title}</h3>
                  <p className="text-white/60 leading-relaxed mt-4">{item.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
